import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space, btnPrimary, btnSecondary } from '../styles/theme.js'

const errorWrap = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${space['2xl']};
  text-align: center;
  min-height: 300px;
`

const errorTitle = css`
  font-size: ${font.size['2xl']};
  font-weight: ${font.weight.bold};
  color: ${colors.text};
  margin-bottom: ${space.sm};
`

const errorMessage = css`
  font-size: ${font.size.base};
  color: ${colors.textSecondary};
  margin-bottom: ${space.lg};
  max-width: 500px;
  line-height: 1.6;
`

const errorDetails = css`
  font-size: ${font.size.sm};
  color: ${colors.textMuted};
  font-family: monospace;
  padding: ${space.md};
  background: ${colors.bgSidebar};
  border-radius: 6px;
  max-width: 600px;
  overflow-x: auto;
  margin-bottom: ${space.lg};
`

const buttonRow = css`
  display: flex;
  gap: ${space.sm};
`

// Error display for caught errors in views
export function ErrorDisplay() {
  return {
    view(vnode) {
      const { error, onRetry } = vnode.attrs
      const message = error?.message || error || 'Something went wrong'
      const status = error?.status

      return m('div', { class: errorWrap }, [
        m('div', { class: errorTitle },
          status === 404 ? 'Not Found'
            : status === 403 ? 'Access Denied'
            : status === 401 ? 'Please Log In'
            : 'Something Went Wrong'),
        m('p', { class: errorMessage },
          status === 404 ? "The page or resource you're looking for doesn't exist."
            : status === 403 ? "You don't have permission to access this resource."
            : status === 401 ? 'Your session may have expired. Please log in again.'
            : message),
        status && !([401, 403, 404].includes(status))
          ? m('div', { class: errorDetails }, `Error ${status}: ${message}`)
          : null,
        m('div', { class: buttonRow }, [
          onRetry
            ? m('button', { class: btnPrimary, onclick: onRetry }, 'Try Again')
            : null,
          m('button', {
            class: btnSecondary,
            onclick: () => m.route.set('/projects'),
          }, 'Go to Projects'),
          status === 401
            ? m('button', {
                class: btnPrimary,
                onclick: () => m.route.set('/login'),
              }, 'Log In')
            : null,
        ]),
      ])
    },
  }
}

// 404 page component
export function NotFoundView() {
  return {
    view() {
      return m(ErrorDisplay, { error: { status: 404 } })
    },
  }
}
